import MatchBar from './MatchBar.svelte';
import CompStandings from './CompStandings.svelte';
import GameWidget from './GameWidget.svelte';
import GameCard from './GameCard.svelte';
import PlayerInfoWidget from './PlayerInfoWidget.svelte';
import TeamInfoWidget from './TeamInfoWidget.svelte';
import RefereeInfoWidget from './RefereeInfoWidget.svelte';
import CoachInfoWidget from './CoachInfoWidget.svelte';
import CompInfoWidget from './CompInfoWidget.svelte';
import CompRatingsWidget from './CompRatingsWidget.svelte';
import BestFive from './BestFive.svelte';
import ProjectClubs from './ProjectClubs.svelte';
import Loader from './Loader.svelte';
import TabView from './TabView.svelte';
import Account from './Account.svelte';
import BettingsLeaderboard from './BettingsLeaderboard.svelte';

const GLOBAL_WIDGET_STYLE_ID = 'ilb-widget-global-styles';
const GLOBAL_WIDGET_STYLES = `
.stats_table-wrap {
    overflow-x: auto;
}

.stats_table {
    width: 100%;
    border-collapse: collapse;
}

.stats_table th,
.stats_table td {
    padding: 10px 12px;
    border: 1px solid #d7dce2;
    font-size: 13px;
    color: #122033;
    text-align: center;
    white-space: nowrap;
}

.stats_table thead th {
    background: #f7f9fc;
    font-weight: 700;
}

.stats_table tbody tr:nth-child(even) {
    background: #fbfcfe;
}

.stats_table th:first-child,
.stats_table td:first-child,
.stats_table th:nth-child(2),
.stats_table td:nth-child(2) {
    //text-align: left;
}
`;

function mountGlobalWidgetStyles() {
    if (document.getElementById(GLOBAL_WIDGET_STYLE_ID)) {
        return;
    }

    const style = document.createElement('style');
    style.id = GLOBAL_WIDGET_STYLE_ID;
    style.textContent = GLOBAL_WIDGET_STYLES;
    document.head.appendChild(style);
}

function mountAll(selector, Component, mapProps) {
    document.querySelectorAll(selector).forEach((target) => {
        if (target.__ilbMounted) {
            return;
        }

        target.__ilbMounted = new Component({
            target,
            props: mapProps(target)
        });
    });
}

function readAttr(element, names, fallback = '') {
    for (const name of names) {
        const value = element.getAttribute(name);
        if (value !== null && value !== undefined && value !== '') {
            return value;
        }

        const datasetKey = name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
        if (element.dataset && element.dataset[datasetKey] !== undefined && element.dataset[datasetKey] !== '') {
            return element.dataset[datasetKey];
        }
    }

    return fallback;
}

function mountWidgets() {
    mountGlobalWidgetStyles();
    mountAll('match-bar', MatchBar, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId']),
        tag: readAttr(el, ['tag', 'info-basket-tag'], 'mlbl')
    }));
    mountAll('comp-standings', CompStandings, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId'])
    }));
    mountAll('game', GameWidget, (el) => ({
        gameId: readAttr(el, ['gameid', 'game-id', 'gameId']),
        tag: readAttr(el, ['tag', 'info-basket-tag'], 'mlbl'),
        season: readAttr(el, ['season']),
        lang: readAttr(el, ['lang'], 'ru'),
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId'])
    }));
    mountAll('player-info', PlayerInfoWidget, (el) => ({
        personId: readAttr(el, ['personid', 'person-id', 'personId', 'playerid', 'player-id', 'playerId']),
        teamId: readAttr(el, ['teamid', 'team-id', 'teamId']),
        tag: readAttr(el, ['tag', 'info-basket-tag']),
        season: readAttr(el, ['season']),
        lang: readAttr(el, ['lang'], 'ru')
    }));
    mountAll('team-info', TeamInfoWidget, (el) => ({
        teamId: readAttr(el, ['teamid', 'team-id', 'teamId']),
        tag: readAttr(el, ['tag', 'info-basket-tag']),
        season: readAttr(el, ['season']),
        lang: readAttr(el, ['lang'], 'ru')
    }));
    // Mount standalone game card widget
    mountAll('game-card', GameCard, (el) => ({
        src: readAttr(el, ['src', 'data-src', 'data-src-url']),
        teamId: readAttr(el, ['teamid', 'team-id', 'teamId']),
        tag: readAttr(el, ['tag', 'info-basket-tag']),
        compId: readAttr(el, ['compid', 'comp-id', 'compId'])
    }));
    mountAll('referee-info', RefereeInfoWidget, (el) => ({
        personId: readAttr(el, ['personid', 'person-id', 'personId'])
    }));
    mountAll('coach-info', CoachInfoWidget, (el) => ({
        personId: readAttr(el, ['personid', 'person-id', 'personId', 'coachid', 'coach-id', 'coachId']),
        teamId: readAttr(el, ['teamid', 'team-id', 'teamId']),
        tag: readAttr(el, ['tag', 'info-basket-tag']),
        season: readAttr(el, ['season']),
        lang: readAttr(el, ['lang'], 'ru')
    }));
    mountAll('comp-info', CompInfoWidget, (el) => ({
        tag: readAttr(el, ['tag', 'comp-tag']),
        season: readAttr(el, ['season']),
        lang: readAttr(el, ['lang'], 'ru')
    }));
    mountAll('comp-ratings', CompRatingsWidget, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId']),
        tag: readAttr(el, ['tag', 'info-basket-tag'], 'mlbl')
    }));
    mountAll('best-five', BestFive, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId']),
        tag: readAttr(el, ['tag', 'info-basket-tag'], 'mlbl')
    }));
    mountAll('project-clubs', ProjectClubs, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId']),
        tag: readAttr(el, ['tag', 'info-basket-tag'], 'mlbl')
    }));
    mountAll('ilb-loader', Loader, (el) => ({
        size: readAttr(el, ['size'], '64px')
    }));
    mountAll('account', Account, (el) => ({
        apiUrl: readAttr(el, ['api-url', 'apiUrl'])
    }));
    mountAll('bettings-leaderboard', BettingsLeaderboard, (el) => ({
        projectId: readAttr(el, ['projectid', 'project-id', 'projectId']),
        start: readAttr(el, ['start']),
        end: readAttr(el, ['end']),
        title: readAttr(el, ['title'], 'Конкурс прогнозов')
    }));
    mountAll('tab-view', TabView, (el) => ({
        panes: Array.from(el.children)
            .filter((child) => child.tagName.toLowerCase() === 'tab-pane')
            .map((pane, index) => ({
                title: pane.getAttribute('title') || `Вкладка ${index + 1}`,
                isActive: pane.hasAttribute('isactive') ? pane.getAttribute('isactive') !== 'false' : undefined,
                disabled: pane.hasAttribute('disabled'),
                panelId: `ilb-tab-panel-${Math.random().toString(36).slice(2)}`,
                content: pane.innerHTML
            }))
    }));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountWidgets, { once: true });
} else {
    mountWidgets();
}

window.ILoveBasketWidgets = {
    version: '2.0.0-svelte',
    mount: mountWidgets
};
